module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer005"
    }
  }, [_c('p', {
    staticClass: "chap-number-new ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Islandport Press")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("PO Box 10")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("Yarmouth, Maine 04096 ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("www.islandportpress.com ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("books@islandportpress.com")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("Copyright © 2018 Sarah Marie Aliberti Jette")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("First Islandport Press edition published May 2018.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("All Rights Reserved.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("This is a work of fiction. Names, characters, businesses, places, events, and incidents are either the products of the author’s imagination or used in a fictitious manner. Any resemblance to actual persons, living or dead, or actual events is purely coincidental.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("ISBN: 978-1-944762-41-4 ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("ISBN: 978-1-944762-46-9 (ebook)")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("Library of Congress Control Number: 2017952157")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "Character-Style-1 CharOverride-7"
  }, [_vm._v("Dean L. Lunt, Publisher")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "Character-Style-1 CharOverride-7"
  }, [_vm._v("Cover and book design: Teresa Lagrange, Islandport Press")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "Character-Style-1 CharOverride-7"
  }, [_vm._v("Printed in the USA by Versa Press ")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-2",
    attrs: {
      "id": "_idContainer006"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-2",
    attrs: {
      "id": "_idContainer007"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame _idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer008"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b15e06e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/what_wind_can_tell_you_interior_12_pt2.vue
// module id = 63
// module chunks = 0